import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid,
  clearIsWBSEValid
} from "../../../redux/fui/index";
import { checkRootExisted } from "../../../redux/fui";
import {
  StyledTooltip, StyledRadioGroup,
  TopRadioWrapper,
  ConfigurationFormLabel,
  StyledFormControl,
  StyledSelect
} from "../FuiStyles";
import { longTextEndDate, rootExistedHint, rootWrongFormatHint } from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import { checkServiceNowTicket, checkWBSECode, checkPOCname, createMaxDate } from "./CommonFunctions";
import priceConfig from "./pricetotierMapping";
import GeneralForm from "./GeneralForm";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import * as fuiRedux from "../../../redux/fui/index";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid, 
  Radio,
  DialogActions,
  MenuItem,
  InputLabel
} from "@material-ui/core";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

/**
 * Automatic Ticket Resolver Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */

const Pamktka= ({
  values, // the value would be changed by user's input
  updateKQForm, //the function to update DPForm values which is from redux
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  minDate,
  maxDate,
  isServiceEndDateInvalid,
  getSelectedEnvironment,
  getServiceEndDate,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  vendorName,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  formClickSubmit,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  // open the dialog when user choose Yes in GDPR
  const config = configurationType === "quick";

  //check whether ServiceNowTicket is valid
  const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);

  // check whether WBSECode and MonthlyTicketVolume are valid
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDialogFlowDevToken, setIsDialogFlowDevToken] = useState(false);

  // Enhanced validation with borders and dialog
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

  // Clear initial loading state for WBSE field on mount
  useEffect(() => {
    // On component mount, if WBSE field is empty, clear the validation state
    // This prevents the initial loader from showing
    if (!values.WBSEcode || values.WBSEcode === '') {
      clearIsWBSEValid();
    }
  }, []); // Run only once on mount
  const [isDialogFlowClientToken, setIsDialogFlowClientToken] = useState(false);
  const [isADGValid, setADGValid] = useState(false);
  const isGDPR = values.GDPR === "yes";
  const [isNoteVisible, setNoteVisible] = useState(true);

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [urlAppName, setURLAppName] = useState("atr");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);

  const [isChecked, setIsChecked] = useState(true);

  // Clear local validation state when Redux values are cleared (configuration type change)
  useEffect(() => {
    // Reset local validation states to match cleared Redux state
    if (values.WBSEcode === '' && values.ProjectName === '' && values.SAPContractID === '') {
      setIsServiceNowTicketValid(true);
      setIsWBSECodeValid(true);
      setIsProjectNameValid(true);
      setIsDialogFlowDevToken(false);
      setIsDialogFlowClientToken(false);
      setADGValid(false);
      setSapContractCodeLength("0");
      setIsTeamNameSelected(true);
      setPocvalid(true);
      setIsPlanInputValid(false);
      setIsChecked(true);
    }
  }, [values]);

  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    if (value === "no") {
      updateKQForm("IsContractIdAvailable", "no")
      updateKQForm("SAPContractID", "0000000000")
      updateKQForm("EndToEndUId", "")
      setSapContractCodeLength(10)
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateKQForm("SAPContractID", "")
      updateKQForm("ClientName", "")
      updateKQForm("EndToEndUId", "")
      setSapContractCodeLength(0)
    }
  };

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    //updateKQForm("ClientName", "")
    updateKQForm("EndToEndUId", "")
    updateKQForm("Company", "")
    updateKQForm("AvanadeCountry", "")
    updateKQForm("AccentureCountry", "")
    updateKQForm("ContractAvailabilityDate", "")
  }

  if (!config) {
    if (externalClientData.length > 0) {
      updateKQForm("ClientName", externalClientData[0])
      updateKQForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateKQForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateKQForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateKQForm("AccentureCountry", externalClientData[4])
      if (isChecked && externalClientData[5] !== undefined){
        if(values.GDPR === 'no')
          updateKQForm("GDPR", externalClientData[5] ? "yes" : "no")
      }
      updateKQForm("ContractAvailabilityDate", "")
      updateKQForm("IsContractIdAvailable", "yes")
    }
  }

  useEffect(() => {
    if (values.PAMPlatformType === "PAM Premium") {
      // Set default selection for dropdown
      if (!values.PAMApps) {
        updateKQForm("PAMApps", "KlewerGenAi-QuasarGenAi-Knowledge Manager");
      }
      setURLAppName("KlewerGenAi-QuasarGenAi-Knowledge-Manager");
    } else {
      // Reset when not PAM Premium
      updateKQForm("PAMApps", "");
      setURLAppName("atr");
    }
  }, [values.PAMPlatformType]);

  updateKQForm("VendorName", vendorName);

  if (!config) {
    isADGValid &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isServiceNowTicketValid &&
      isADGValid &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && isTeamNameSelected)
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateKQForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    re.test(value) && updateKQForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate" || fieldName === "ContractAvailabilityDate") {
      updateKQForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateKQForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateKQForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    }
    else {
      const { value } = event.target;
      event.preventDefault();
      updateKQForm(fieldName, value);
      if (fieldName === "WBSEcode") {
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "RITM") {
        setIsServiceNowTicketValid(checkServiceNowTicket(value, isChecked, config));
      }
      if (fieldName === "DialogFlowDevToken") {
        if (value.length > 0) {
          setIsDialogFlowDevToken(true);
        } else {
          setIsDialogFlowDevToken(false);
        }
      }
      if (fieldName === "DialogFlowClientToken") {
        if (value.length > 0) {
          setIsDialogFlowClientToken(true);
        } else {
          setIsDialogFlowClientToken(false);
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }

      if (fieldName === "AdminDistributionGroup" && value.length > 0) {
        setADGValid(true);
      } else if (fieldName === "AdminDistributionGroup" && value.length <= 0) {
        setADGValid(false);
      }

      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateKQForm("DeploymentRegion", "");
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dh")
        } else if (value == "virginia") {
          setRegionCode("dh1")
        } else if (value == "frankfurt") {
          setRegionCode("dh2")
        } else if (value == "singapore") {
          setRegionCode("dh3")
        } else if (value == "tokyo") {
          setRegionCode("dh4")
        } else if (value == "ireland") {
          setRegionCode("dh5")
        } else if (value == "london") {
          setRegionCode("dh6")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateKQForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateKQForm("Tier", "")
        } else {
          setEnv("")
          updateKQForm("Tier", "")
        }
      }
      if (fieldName === "PAMApps") {
        if (value === "KlewerGenAi-QuasarGenAi-Knowledge Manager") {
          setURLAppName("KlewerGenAi-QuasarGenAi-Knowledge-Manager");
        } else {
          setURLAppName("atr");
        }
      }
    }
  };

  getSelectedEnvironment(env);
  updateKQForm("Environment", env);

  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
  updateKQForm("ConfigurationType", configurationType);

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);

  //form validation
  const validateInputFields = (step) => {
    // Only validate on final submit (step 2) or when explicitly called with 'submit'
    if (step !== 'step2' && step !== 'submit') {
      return true; // Skip validation for intermediate steps
    }

    let ispass = true;
    const missingFields = [];

    // Collect all required fields for final validation
    let allRequiredFields = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'DeploymentRegion',
      'DomainContextRoot',
      'Environment',
      'Tier',
      'AdminDistributionGroup',
      'TentativeServiceEndDate',
      'PAMPlatformType'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      if (isChecked) {
        allRequiredFields.push('SAPContractID');
      } else {
        allRequiredFields.push('Pocdetails', 'ClientName', 'RITM');
      }
      allRequiredFields.push('UsersDistributionGroup');
    }

    // Check each required field
    for (const fieldname of allRequiredFields) {
      let isFieldInvalid = false;

      if (fieldname === "WBSEcode" && (!values[fieldname] || values[fieldname] === "" || !isWBSEValid)) {
        isFieldInvalid = true;
        missingFields.push(`${fieldname} (${!isWBSEValid ? 'Invalid WBSE code' : 'Required'})`);
      } else if (fieldname === "RITM" && (!values[fieldname] || values[fieldname] === "" || !isServiceNowTicketValid)) {
        isFieldInvalid = true;
        missingFields.push(`${fieldname} (${!isServiceNowTicketValid ? 'Invalid format' : 'Required'})`);
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (!values[fieldname] || values[fieldname] === "") {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      }

      if (isFieldInvalid) {
        ispass = false;
      }
    }

    // Use the new validation handler
    handleValidationResult(ispass, missingFields, formClickSubmit);

    return ispass;
  }

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={0}
        validateInputFields={validateInputFields}
        ClientContractFields={
          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>

                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""}

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }
            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }

                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponent
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        idkey="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config) &&
                  <Grid item xs={8}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                  </Grid>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >}
                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                
                {config &&
                  <Grid item xs={8}>
                    {FormField.ServiceNowTicket(handleChange, values, isServiceNowTicketValid)}
                  </Grid>
                }
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
                </Grid >
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            {!config ? <p> Expected Custom URL: <span style={{ color: " #0041F0" }}>https://{regionCode}-{domainContextRoot}.atrmywizard-aiops.com/{urlAppName}</span></p> : ""}
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >

                <Grid item xs={12}>
                  {PlatformFormField.GDPRPlatformField(
                    values,
                    handleChange,
                    isGDPR,
                    classes,
                    config,
                    isChecked,
                    externalClientData
                  )}
                </Grid>

                <Grid item xs={3}>
                  {PlatformFormField.DeploymentRegionPlatformField(
                    values,
                    handleChange,
                    isGDPR
                  )}
                </Grid>

                <Grid item xs={6}>
                  {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                    values,
                    handleChangeRootSuggestions,
                    isRootExist,
                    rootExistedHint,
                    rootWrongFormatHint,
                    externalClientData,
                    domainContextRoot,
                    isLoading
                  ) : PlatformFormField.DomainContextRootPlatformField(
                    values,
                    handleChangeRoot,
                    isRootExist,
                    rootExistedHint,
                    isLoading
                  )}
                </Grid>

                <Grid item xs={3}>
                  {PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
                <Grid item xs={3}>
                  {PlatformFormField.PamTierPlatformField(values, handleChange)}
                  {values.Tier && (
                    <div>
                      <em style={{ fontSize: "small", color: "#0033CC" }}>
                        Infra & service cost per month:{" "}
                        {priceConfig.priceToTier[values.Tier] &&
                          priceConfig.priceToTier[values.Tier].price}{" "}
                      </em>
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={6}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              {!config &&
                <Grid item xs={6}>
                  {FormField.UsersDistributionGroupField(handleChange, values)}
                </Grid>
              }
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
              <Grid item xs={6}>
                {FormField.PAMPlatformType(values, handleChange)}
              </Grid>
              {config &&
                <Grid item xs={6}>
                </Grid>}
             {values.PAMPlatformType === "PAM Premium" && (
                <Grid item xs={6}>
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" style={{ paddingTop: "10px" }}>
                      PAM Applications
                    </FormLabel>
                    <StyledFormControl variant="outlined" margin="dense" fullWidth style={{ marginTop: "10px" }}>
                      <InputLabel htmlFor="pam-applications">Select Application</InputLabel>
                      <StyledSelect
                        value={values.PAMApps || ""}
                        onChange={(e) => handleChange(e, "PAMApps")}
                        label="Select Application"
                        inputProps={{
                          name: 'PAMApps',
                          id: 'pam-applications',
                        }}
                      >
                        <MenuItem value="">
                          <em>--Select Application--</em>
                        </MenuItem>
                        <MenuItem value="KlewerQuasar">
                          Knowledge Transition + Knowledge Assistant
                        </MenuItem>
                      </StyledSelect>
                    </StyledFormControl>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </div>
        
        }
        history={history}
        belong={vendorName}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions >
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  values: state.fui.KQForm,
  isRootExist: state.fui.isRootExist,
  isWBSEValid: state.fui.isWBSEValid,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
});
 
 
export default connect(MSTP, {
  checkDomainAvaliable: checkRootExisted,
  updateKQForm: fuiRedux.updateKQForm,
  fetchExternalClientDetails,
  checkIsWBSEValid,
  clearIsWBSEValid,
})(withRouter(Pamktka));